import { format } from 'date-fns'

const getters = {
  createdAt: () => (model) => {
    const createdAt = model.get('createdAt')
    if (createdAt) {
      return format(createdAt, 'YYYY年M月D日')
    }
  },

  birthDay: () => (model) => {
    const birthDay = model.get('birthDay')
    if (birthDay) {
      return format(birthDay, 'YYYY年M月D日')
    }
  }
}

export default {
  namespaced: true,
  getters
}
